import ugc from "@/mixins/UGC";

import { getLocale } from "@/data/regionInfo";
import { external3DScene } from '@/mixins/external3DScene';

export default {
  mixins: [ ugc, external3DScene ],
  data() {
    return {
      tempPattern: null,
      originalImageUrl: "",
      originalSwatch: null,
      originalSticker: null,
      enableCarouselNavigation: false,
      disableBackButton: true,
      disableButtons: false,
      disableStatus: false,
      patternTempRecipe: null,
    }
  },
  computed:{
    stickerGroups() {
      let stickersOrderById, availableStickers, availableGroups = [];
      if (this.isMainApp) {
        stickersOrderById = this.stickersId;
        availableStickers = this.$store.state.utils.availableStickers;
      } else {
        stickersOrderById = this.$store.getters["utils/availableStickersOrderByComponent"];
        availableStickers = this.$store.getters[ "utils/availableStickersByComponent"];
      }

      if (this.enableStickerGroups) {
        const availableGroupNames = [];

        availableStickers.forEach(sticker => {
          if (sticker.groups && sticker.groups.length) {
            availableGroupNames.push(...sticker.groups.filter(group =>
              stickersOrderById.includes(Number(sticker.id)) && !availableGroupNames.includes(group)
            ));
          }
        });

        availableGroups = this.$store.state.utils.availableStickersByGroup
          .filter(group => availableGroupNames.includes(group.name))
          .sort((a, b) => {
            let value = 0

            if (a.hasOwnProperty('order') && b.hasOwnProperty('order')) {
              value = a.order - b.order;
            } else if (a.hasOwnProperty('order')) {
              value = -1;
            } else if (b.hasOwnProperty('order')) {
              value = 1;
            }

            return value;
          });
      }

      return availableGroups;
    },
    stickers() {
      let stickersOrderById, availableStickers, stickers;
      if (this.isMainApp) {
        stickersOrderById = this.stickersId;
        availableStickers = this.$store.state.utils.availableStickers;
      } else {
        stickersOrderById = this.$store.getters["utils/availableStickersOrderByComponent"];
        availableStickers = this.$store.getters[ "utils/availableStickersByComponent"];
      }

      if (this.enableStickerGroups) {
        const filteredStickers = availableStickers
          .filter(sticker => stickersOrderById.includes(Number(sticker.id)))
          .sort((a, b) => stickersOrderById.indexOf(Number(a.id)) - stickersOrderById.indexOf(Number(b.id)));

        stickers = [];
        this.stickerGroups.forEach(({ name }) => {
          stickers.push(...filteredStickers
            .filter(sticker => sticker.groups.includes(name))
            .map(sticker => {
              const originalGroup = name;
              const alternativeGroup = originalGroup === 'new' ? sticker.groups.find(name => name !== 'new') : null;

              return {
                ...sticker,
                originalGroup,
                alternativeGroup
              }
            })
          );
        });
      } else {
        stickers = availableStickers.sort((a, b) => stickersOrderById.indexOf(Number(a.id)) - stickersOrderById.indexOf(Number(b.id)));
      }

      return stickers.map(sticker => ({
        ...sticker,
        thumb: this.getSwatchImage(sticker.image_assets.thumb)
      }));
    },
    activeUGCComponent() {
      return this.$store.state.patternMaker.activeUGCComponent;
    },
    previewImageUrl() {
      const path = this.previewImagePath;
      if (!path) return '';
      const startsWithHttpRegex = /^https?:\/\//;
      const isUrlAbsolute = startsWithHttpRegex.test(path);
      if (isUrlAbsolute) {
        return path;
      }
      const domain = this.$store.state.endPoints.patternmaker.s3Url || this.$store.state.endPoints.customizer.s3Url || '';
      return `${domain}${path}`;
    },
    enableStickerGroups() {
      return this.$store.state.utils.configuration.enableStickerGroups;
    },
    previewImagePath() {
      return this.$store.state.patternMaker.previewImage.url;
    },
    previewImageId() {
      return this.$store.state.patternMaker.previewImage.id;
    },
    queryParams() {
      return this.$store.state.utils.queryParams;
    },
    highligthSelectSwatchInstructions() {
      return this.$store.state.patternMaker.highligthSelectSwatchInstructions;
    },
    highligthSelectStickerInstructions() {
      return this.$store.state.patternMaker.highligthSelectStickerInstructions;
    },
    spinnerSize() {
      return this.$store.getters["utils/returnSpinnerSize"];
    },
    previewImageDataIsReady() {
      return this.$store.state.patternMaker.previewImage.dataIsReady;
    },
    translations() {
      return this.$store.state.translations.data;
    },
    configuration() {
      return this.$store.state.utils.configuration;
    },
    useEcomDataLayerFormat() {
      return this.$store.getters['utils/useEcomDataLayerFormat'];
    },
    currentSwatch() {
      return this.$store.state.patternMaker.selectedSwatch[this.activeUGCComponent];
    },
    currentSticker() {
      return this.$store.state.patternMaker.selectedSticker[this.activeUGCComponent];
    },
    assetsPath() {
      return this.$store.state.endPoints.customizer.customsAssets;
    },
    swatches() {
      const swatches = this.isMainApp ? this.$store.state.utils.availableSwatches : this.$store.getters["utils/availableSwatchesByComponent"];
      return swatches.map(swatch => ({
        ...swatch,
        thumb: swatch.image_assets && swatch.image_assets.ui ? this.getSwatchImage(swatch.image_assets.ui) : null
      }));
    },
    activeUGCIndex() {
      return this.$store.state.ugc.tempData.activeUGCIndex;
    },
    canvasActive() {
      return this.$store.getters["utils/canvasActive"];
    },
  },
  methods: {
   /**
   * @function finish
   * Finish and close pattern maker
   */
    finish() {
      if (this.useEcomDataLayerFormat) {
        this.$patternMakerDatalayer.logAnalyticsEvent({eventLabel:this.$patternMakerDatalayer.labels.finish});
      }
      if (!this.isMainApp) {
        let hasErrors = false;
        if (!this.currentSwatch) {
          hasErrors = true;
          this.$store.commit("patternMaker/SET_HIGHLIGHT_SELECT_SWATCH_INSTRUCTIONS", true);
        }
        if (!this.currentSticker) {
          hasErrors = true;
          this.$store.commit("patternMaker/SET_HIGHLIGHT_SELECT_STICKER_INSTRUCTIONS", true);
        }
        if (hasErrors || !this.previewImageDataIsReady) {
          return;
        }

        const { activeUGCComponent } = this.$store.state.ugc.tempData.features[this.activeUGCIndex];

        this.trackData();
        this.$emit('disableStatus', true);
        this.$store.commit('swatches/SET_SWATCHES_SELECTED', {
          component: activeUGCComponent,
          data: {
            ...this.$store.state.swatches.selectedSwatches[activeUGCComponent],
            default: false,
          },
        });
        this.applySavePreviousSwatch();
        this.$store.commit("patternMaker/SET_PATTERN", { ...this.tempPattern, touched: true });

        this.setPreviewImageIsLoading(true);

        let promises = [this.applyPatternUGCSwatch(activeUGCComponent)];
        if (this.isSecondaryPatternStickerApplicable(this.currentSticker)) {
          promises.push(this.createSecondaryPatternStickers(this.currentSwatch, this.currentSticker));
        }
        return Promise.all(promises)
          .then(() => {
            // apply deco stitch if found
            this.$eventBus.$emit('re-apply-decostitch');
            return this.$store.dispatch("swatches/GET_RELATION_SWATCH_BY_FEATURE_ID", "checkerboard");
          })
          .then(({ swatches_not_allowed }) => {
            this.$store.commit("swatches/SET_DISABLED_SWATCHES_BY_FEATURE", { swatches: swatches_not_allowed, feature: "patternMaker" });
            // updates the price
            this.$store.dispatch("buyPanel/GET_PRICE", { recipe: this.$store.state.recipe.recipe_v2});

            // Set onbeforeunload event
            this.$eventBus.$emit("set-onbeforeunload", true);
            // updates the navigation component
            this.$eventBus.$emit("update-menu-item-state");
            // updates tabs
            this.$eventBus.$emit("block-features-by-swatch-id");
            this.resetGeometrybyUGCFeature();

            // NOTE this.previewImageDataIsReady should be true to close the modal
            this.setPreviewImageIsLoading(false);

            this.closeModalOption();
            this.$emit('disableStatus', false);
          })
          .catch(err => {
            this.$emit('disableStatus', false);
            console.error('PatternMaker finish: ', err);
          });
      }
      this.$eventBus.$emit("patternmaker-selected-style", null);
      this.$eventBus.$emit("patternmaker-save-data", {
        swatchId: this.currentSwatch,
        stickerId: this.currentSticker,
        imageId: this.previewImageId,
        imageUrl: this.previewImageUrl,
      });
    },
    selectSticker(sticker) {
      if (!this.isMainApp) {
        this.trackData('select pattern sticker');
        if (!this.previewImageDataIsReady || sticker.id === this.currentSticker) return;
        this.setPreviewImageIsLoading(true);
        if (!this.currentSwatch) {
          this.$store.commit("patternMaker/SET_HIGHLIGHT_SELECT_SWATCH_INSTRUCTIONS", true);
          this.setPreviewImageIsLoading(false);
          return;
        }
        this.$store.commit("patternMaker/SET_HIGHLIGHT_SELECT_STICKER_INSTRUCTIONS", false);
        this.$store.commit("patternMaker/SET_SELECTED", {
          swatch: this.currentSwatch,
          sticker: sticker.id,
          componentName: this.activeUGCComponent,
        });
        this.getPatternImages({ sticker: sticker.id })
          .catch(console.error);
      } else {
        this.$eventBus.$emit("patternmaker-select-sticker", sticker);
      }
    },
    checkEnableCarouselNavigation() {
      this.enableCarouselNavigation = window.innerWidth >= 768;
    },
    setPreviewImageIsLoading(isLoading) {
      this.$store.commit('patternMaker/UPDATE_PREVIEW_IMAGE', { dataIsReady: !isLoading });
    },
    createSecondaryPatternStickers(currentSwatch, currentSticker) {
      const secondaryComponent = this.$store.getters["ugc/getUGCComponentNotActive"];

      const patternAlreadyCreated = this.$store.state.patternMaker.currentPattern.hasOwnProperty(secondaryComponent);
      const patternMakerApplied = this.$recipe.checkForPatternMaker().includes(secondaryComponent);
      // sticker already exist for this component or model does not have a second component available
      if ((patternAlreadyCreated && patternMakerApplied) || !secondaryComponent) {
        return false;
      }
      const params = {
        model: this.pdm.sku,
        componentName: secondaryComponent,
        size: this.returnUGCSize(),
        swatch_id: currentSwatch,
        sticker_id: currentSticker
      };
      this.$store.commit("patternMaker/SET_SELECTED", {
        swatch: currentSwatch,
        sticker: currentSticker,
        componentName: secondaryComponent
      });
      return this.$store
        .dispatch("patternMaker/CREATE_PATTERN", params)
        .then(({ data }) => {
          this.$store.commit("patternMaker/SET_PATTERN", { data, componentName: secondaryComponent });
        });
    },
    /**
     * @function isSecondaryPatternStickerApplicable
     * @param {String} currentSticker
     * Checks if the the ugc_swatch for the second component should be generated.
     * In authentic classic, there are restrictions with flames and drips.
     * They only are valid in vamp component.
     */
    isSecondaryPatternStickerApplicable(currentSticker) {
      const secondaryComponent = this.$store.getters["ugc/getUGCComponentNotActive"];
      if (!!secondaryComponent) {
        const { available_stickers: availableStickers  } = this.$store.state.utils.availablePatternMakerContent[this.pdm.sku]
        && this.$store.state.utils.availablePatternMakerContent[this.pdm.sku][secondaryComponent];
        return availableStickers.includes(Number(currentSticker));
      };
      return false;
    },
    getSwatchImage(image) {
      const type = this.isMainApp ? 'patternmaker' : 'customizer';
      return this.$store.getters['utils/addCacheBusting'](this.$store.getters['endPoints/swatchesPath'](type) + image);
    },
    async getProductImages() {
      if (this.configuration.enableSnapshotService) {
        const data = await this.initExternal3Dscene({domEl: "snapshot-image-scene", snapshotSize: "md", snapshotView: "checkerboard_creator", showSnapShot: true});
        return new Promise((resolve) => {
          this.setPreviewImageIsLoading(false);
          this.$store.commit('patternMaker/UPDATE_PREVIEW_IMAGE', { url: data.fileUrl });
          resolve();
        })
      } else {
        return this.$store
          .dispatch("ugc/tempData/GET_PRODUCT_IMAGES_BY_RECIPE", {
            recipe: this.patternTempRecipe,
            images: this.pdm.product_images.featured_views.checkerboard,
            locale: getLocale()
          })
          .then(images => {
            const { view, size } = this.pdm.product_images.featured_views.checkerboard[0];
            // If same image from response, remove loading spinner and enable new swatch selection
            if (this.previewImageUrl === images[`${view}_view`][size]) {
              this.setPreviewImageIsLoading(false);
            }
            this.$store.commit('patternMaker/UPDATE_PREVIEW_IMAGE', { url: images[`${view}_view`][size] });
          })
          .catch(err => {
            console.error(err);
            return Promise.reject(err);
          });
      }
    },
    setInitialValues(event) {
      if (!this.isMainApp) {
        const { activeUGCComponent } = this.$store.state.ugc.tempData.features[this.activeUGCIndex];
        this.$store.commit('patternMaker/SET_ACTIVE_UGC_COMPONENT', activeUGCComponent);
        this.originalImageUrl = this.$store.state.patternMaker.previewImage.url;
        this.setPreviewImageIsLoading(true);

        // checks if the swatcher and the sticker are present in the URL and use them
        if (
          this.queryParams.feature === 'patternMaker'
          && this.queryParams.recipe
          && Object.keys(this.$store.state.patternMaker.currentPattern).includes(activeUGCComponent)
          && (
            !this.$store.state.patternMaker.selectedSwatch[activeUGCComponent]
            || !this.$store.state.patternMaker.selectedSticker[activeUGCComponent]
          )
        ) {
          this.$store.commit("patternMaker/SET_SELECTED", {
            swatch: String(this.queryParams.swatchId),
            sticker: String(this.queryParams.stickerId),
            componentName: this.activeUGCComponent,
          });
        }

        this.originalSwatch = this.$store.state.patternMaker.selectedSwatch[activeUGCComponent];
        this.originalSticker = this.$store.state.patternMaker.selectedSticker[activeUGCComponent];

        this.patternTempRecipe = JSON.parse(JSON.stringify(this.$store.state.recipe.recipe_v2));
        if (this.$store.state.patternMaker.currentPattern[activeUGCComponent]) {
          const { ugc, swatch_id } = this.$store.state.patternMaker.currentPattern[ activeUGCComponent ];
          this.tempPattern = {
            data: JSON.parse(JSON.stringify(this.$store.state.patternMaker.currentPattern[activeUGCComponent])),
            componentName: activeUGCComponent
          };

          this.savePatternTempRecipe(
            activeUGCComponent,
            Number(swatch_id),
            JSON.parse(JSON.stringify(ugc))
          );
        }

        this.getProductImages()
          .catch(console.error)
      }
    },
    applySavePreviousSwatch() {
      const { activeUGCComponent } = this.$store.state.ugc.tempData.features[this.activeUGCIndex];
      const feature = this.$recipe.getUGCFeatureType(activeUGCComponent);

      this.savePreviousSwatch({ saveComponents: [{
        component: activeUGCComponent,
        feature,
        isSameFeature: feature === 'patternMaker',
      }] });
    },
    savePatternTempRecipe(componentName, swatchId, ugc){
      const { components = {} } = this.patternTempRecipe;
      if (!components[componentName]) components[componentName] = {};
      components[componentName].swatch_id = swatchId;
      components[componentName].material_type = "canvas";
      components[componentName].group = "patterns";
      components[componentName].subgroup = "checkerboard-creator";
      components[componentName]= {
        ...components[componentName],
        ugc
      };
    },
    returnUGCSize() {
      return this.$recipe.getUGCSizeFromRecipe() || this.pdm.ugcDefaultSize;
    },
    getPatternImages({ swatch, sticker }) {
      const { activeUGCComponent } = this.$store.state.ugc.tempData.features[this.activeUGCIndex];
      const ugcSize = this.returnUGCSize();
      const params = {
        model: this.pdm.sku,
        componentName: activeUGCComponent,
        size: ugcSize
      };
      const swatch_id = swatch || this.currentSwatch;
      const sticker_id = sticker || this.currentSticker;
      if (swatch_id) params.swatch_id = swatch_id;
      if (sticker_id) params.sticker_id = sticker_id;

      return this.$store
        .dispatch("patternMaker/CREATE_PATTERN", params)
        .then(data => {
          const { ugc } = data.data;
          this.tempPattern = data;
          /**
           * TODO Use the swatch_id from patternMaker.currentPattern[activeUGCComponent]
           * Currently image service doesn't know where to pull from the patternMaker swatches
           */
          this.applyTexture({imgUrl: ugc?.ugc_swatch?.image_url, componentName: activeUGCComponent})
        }).then(() => {
          this.animateExternal3dScene();
          this.savePatternTempRecipe(
            activeUGCComponent,
            Number(swatch_id),
            JSON.parse(JSON.stringify(ugc))
          );
        })
        .then(this.getProductImages)
        .catch(err => {
          console.error(err);
          return Promise.reject(err);
        });
    },
    trackData(eventLabel = 'finish') {
      if (!this.useEcomDataLayerFormat) {
        let eventAction = 'pattern maker';
        if (this.$store.getters['patternMaker/isSecondComponentFlow']) eventAction += ' - second component';
        const dataLayerSource = this.canvasActive ? parent.dataLayer : dataLayer;
        dataLayerSource.push({
          event: "trackEvent",
          eventCategory: "customs",
          eventAction: eventAction,
          eventLabel
        });
      }
    },
    selectSwatch(swatch) {
      if (!this.isMainApp) {
        this.trackData('select base pattern');

        if (!this.previewImageDataIsReady || swatch.id === this.currentSwatch) return;
        this.setPreviewImageIsLoading(true);
        this.$store.commit("patternMaker/SET_HIGHLIGHT_SELECT_SWATCH_INSTRUCTIONS", false);

        this.$store.commit("patternMaker/SET_SELECTED", {
          swatch: swatch.id,
          sticker: this.currentSticker,
          componentName: this.activeUGCComponent,
        });
        this.getPatternImages({ swatch: swatch.id })
          .catch(console.error);
      }
      this.$eventBus.$emit("patternmaker-select-swatch", swatch);
    },
    setDisableStatus(status) {
      this.disableStatus = status;
    },
    applyPatternMakerTo3D(component) {
      this.applyPatternUGCSwatch(component)
        .then(() => this.$eventBus.$emit('re-apply-decostitch'))
        .then(() => this.$store.dispatch(
          'swatches/GET_RELATION_SWATCH_BY_FEATURE_ID',
          'checkerboard'
        ))
        .then(({ swatches_not_allowed }) => this.$store.commit(
          'swatches/SET_DISABLED_SWATCHES_BY_FEATURE',
          { swatches: swatches_not_allowed, feature: "patternMaker" },
        ));
      this.resetGeometrybyUGCFeature();

      // Set onbeforeunload event
      this.$eventBus.$emit("set-onbeforeunload", true);
      // updates tabs
      this.$eventBus.$emit("block-features-by-swatch-id");
    },
    closeModal(isClosed = true) {
      if (!isClosed) return;
      if (this.configuration.enablePatternExitAlert) {
        if (this.translations.patternMakerExitAlertMessage) {
          this.$modal.hide('patternMaker');
          this.$eventBus.$emit('hide-pattern-maker', 'exit');
        }
      } else {
        this.$modal.hide('patternMaker');
        this.$eventBus.$emit('hide-pattern-maker', 'exit');
      }
    },
    closeModalOption(closeType) {
      if (this.useEcomDataLayerFormat) {
        this.$patternMakerDatalayer.logAnalyticsEvent({eventLabel:this.$patternMakerDatalayer.labels.cancel});
      }
      if (!this.isMainApp) {
        if (!this.previewImageDataIsReady) {
          return;
        }

        this.patternTempRecipe = null;
        this.tempPattern = null;

        // on 'exit' or 'cancel' restore the original values in the vuex store
        if (closeType) {
          this.$store.commit('patternMaker/UPDATE_PREVIEW_IMAGE', { url: this.originalImageUrl });
          this.$store.commit("patternMaker/SET_SELECTED", {
            swatch: this.originalSwatch,
            sticker: this.originalSticker,
            componentName: this.activeUGCComponent
          });
        }

        // reset error messages
        this.$store.commit("patternMaker/SET_HIGHLIGHT_SELECT_SWATCH_INSTRUCTIONS", false);
        this.$store.commit("patternMaker/SET_HIGHLIGHT_SELECT_STICKER_INSTRUCTIONS", false);

        let eventLabel = null;
        if (closeType === 'cancel') {
          eventLabel = 'cancel';
        } else if (closeType === 'exit') {
          eventLabel = 'close modal click';
        }
        if (eventLabel) {
          this.trackData(eventLabel);
        }

        this.$modal.hide('patternMaker');
      }
      this.$eventBus.$emit('patternmaker-exit', closeType);
    }
  },
};
